export class VaultsFilterConditions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "FreeTextFilters",
            "format": ""
        },
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "CloudProviderFilters",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "VaultRegionFilters",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "VaultStatusFilters",
            "format": ""
        },
        {
            "name": "vaultType",
            "baseName": "vaultType",
            "type": "VaultTypeFilters",
            "format": ""
        },
        {
            "name": "encryptionType",
            "baseName": "encryptionType",
            "type": "VaultEncryptionTypeFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return VaultsFilterConditions.attributeTypeMap;
    }
    constructor() {
    }
}
